import React, { useEffect, useState } from "react";
import { finApi, money } from "@/lib/financeApi";
import { useLoad, Loading, ErrorBox, field } from "@/components/nds/windows/finance/parts";
import { Awaiting, Payables } from "@/components/nds/windows/finance/payables/Parts1";
import { Checks, Reimbursements, FundingLog } from "@/components/nds/windows/finance/payables/Parts2";

/** Finance Engine card: Invoice Funding & Landlord Payables (reads invoices, paystubs, landlord checks and reimbursables; writes nothing). */
export default function FinLandlordPayablesContent() {
  const [win, setWin] = useState({ from: "2026-05-01", to: "2026-10-28" });
  const [state, load] = useLoad(() => finApi.get("/landlord-payables", { checks_from: win.from, checks_to: win.to }), [win.from, win.to]);
  useEffect(() => { const f = () => load(); window.addEventListener("fin:ledger-changed", f); return () => window.removeEventListener("fin:ledger-changed", f); }, [load]);
  const d = state.data;
  return (
    <div className="p-5 space-y-4 text-nex-silver" data-testid="fin-landlord-payables">
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-0"><h2 className="font-serif text-2xl">Invoice Funding &amp; Landlord Payables</h2>
          <p className="text-xs text-nex-muted">The gap between paystubs already issued and employer invoices not yet funded.</p></div>
        <label className="ml-auto text-[10px] text-nex-muted">Checks from<input type="date" value={win.from} onChange={(e) => setWin((w) => ({ ...w, from: e.target.value }))} className={`${field} !py-1 ml-1`} data-testid="lp-checks-from" /></label>
        <label className="text-[10px] text-nex-muted">to<input type="date" value={win.to} onChange={(e) => setWin((w) => ({ ...w, to: e.target.value }))} className={`${field} !py-1 ml-1`} data-testid="lp-checks-to" /></label>
      </div>
      {state.loading && !d && <Loading testid="lp-loading" />}
      {state.error && <ErrorBox testid="lp-error" error={state.error} onRetry={load} />}
      {d && <>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="lp-kpis">
          {[["Awaiting funding", d.awaiting.total, "lp-kpi-awaiting"], ["Gross landlord payable", d.payables.gross_total, "lp-kpi-gross"],
            ["Checks written + reimbursements", d.payables.checks_written + d.payables.reimbursements, "lp-kpi-less"], ["Net once open invoices fund", d.payables.net_when_funded, "lp-kpi-net"]].map(([l, v, t]) => (
            <div key={t} className="p-3 rounded-md border border-white/10 bg-white/[0.03]" data-testid={t}><div className="nds-label-dim text-[9px]">{l}</div>
              <div className={`font-mono text-lg ${v < 0 ? "text-emerald-300" : "text-nex-silver"}`}>{v < 0 ? `Ahead ${money(-v)}` : money(v)}</div></div>))}
        </div>
        <div className="grid gap-4 xl:grid-cols-2">
          <Awaiting a={d.awaiting} />
          <Payables a={d.awaiting} p={d.payables} landlord={d.landlord.name} />
          <Checks rows={d.checks} win={d.checks_window} total={d.payables.checks_written} />
          <Reimbursements rows={d.reimbursements} total={d.payables.reimbursements} />
        </div>
        <FundingLog rows={d.funding_log} wc={d.write_check} onChanged={load} />
      </>}
    </div>
  );
}
